import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { Storage } from '../../Firebase/firebase';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { getClubDetails , addbusinessToClub } from '../../../_services';
import '../AddClub/AddClubFinal.css';

const JoinClub = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const formRef = useRef();
    const [loading, setLoading] = useState(false);
    const [clubId, setClubId] = useState('');
    const [club, setClub] = useState('');
    const [isInitialized, setIsInitialized] = useState(false);

    // Get current language direction
    const isRTL = i18n.language === 'he';

    // Check for business ID on component mount
    useEffect(() => {
        const checkBusinessId = async () => {
            const userData = localStorage.getItem('user');
            if (!userData) {
                toast.error(t('businessIdNotFound'));
                navigate('/');
                return;
            }

            try {
                const parsedUserData = JSON.parse(userData);
                if (!parsedUserData.business_id) {
                    // Wait a bit and try again
                    await new Promise(resolve => setTimeout(resolve, 1000));
                    const updatedUserData = localStorage.getItem('user');
                    const updatedParsedData = JSON.parse(updatedUserData);
                    if (!updatedParsedData.business_id) {
                        toast.error(t('businessIdNotFound'));
                        navigate('/');
                        return;
                    }
                }
                setIsInitialized(true);
            } catch (error) {
                console.error('Error parsing user data:', error);
                toast.error(t('businessIdNotFound'));
                navigate('/');
            }
        };

        checkBusinessId();
    }, [navigate, t]);


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!isInitialized) {
            toast.error(t('pleaseWait'));
            return;
        }


        if (!clubId) {
            toast.error(t('clubIdRequired'));
            return;
        }

        if (!formRef.current.terms.checked) {
            toast.error(t('termsRequired'));
            return;
        }

        setLoading(true);
        try {
            const userData = JSON.parse(localStorage.getItem('user'));
            if (!userData || !userData.business_id) {
                throw new Error(t('businessIdNotFound'));
            }

            const formData = {
                clubId: formRef.current.id.value,
                email: formRef.current.email.value,
            };

            const clubResponse = await getClubDetails(formData.clubId);
            const club = clubResponse;

            if (!club || Object.keys(club).length === 0) {
                // TODO: add tex
                throw new Error(t('joinClubFailed'));
            }

            localStorage.setItem('clubId', JSON.stringify(club));

            const addBusinessResponse = await addbusinessToClub({id : userData.business_id});
            const result = addBusinessResponse;

            if (!result) {
                throw new Error(t('addBusinessFailed'));
            }
            // TODO: add text
            toast.success(t('joinedClub'));
            navigate(-1);
        } catch (error) {
            console.error('Error join to club:', error);
            // TODO: add text
            toast.error(error.message || t('joinClubFailed'));
        } finally {
            setLoading(false);
        }
    };

    if (!isInitialized) {
        return (
            <div className="add-club-container" dir={isRTL ? 'rtl' : 'ltr'}>
                <div className="add-club-form-container">
                    <div className="add-club-form-header">
                        <h1>{t('loading')}</h1>
                        <p>{t('pleaseWait')}</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="add-club-page-container" dir={isRTL ? 'rtl' : 'ltr'}>
            <ToastContainer />
            <div className="add-club-container" dir={isRTL ? 'rtl' : 'ltr'}>
                <div className="add-club-form-container">
                    <div className="form-card-accent"></div>
                    <div className="add-club-form-header">
                        <h1>{t('joinClub')}</h1>
                        <p>{t('joinClubDescription')}</p>
                    </div>

                    <form ref={formRef} onSubmit={handleSubmit} className="add-club-form">
                        <div className="add-club-form-content">
                            <div className="add-club-form-row">
                                <div className="add-club-form-group">
                                    <label className="add-club-form-label">
                                        {t('clubId')}
                                    </label>
                                    <input
                                        name="id"
                                        type="text"
                                        onChange={(e) => setClubId(e.target.value)}
                                        value={clubId}
                                        className="add-club-form-input"
                                        placeholder={t('clubIdPlaceholder')}
                                    />
                                </div>

                                <div className="add-club-form-group">
                                    <label className="add-club-form-label">
                                        {t('email')}
                                    </label>
                                    <input
                                        name="email"
                                        type="email"
                                        //required
                                        className="add-club-form-input"
                                        placeholder={t('emailPlaceholder')}
                                    />
                                </div>
                            </div>

                            <div className="add-club-form-row">
                                <div className="add-club-form-group">
                                    <label className="add-club-form-label">
                                        {t('phoneNumber')}
                                    </label>
                                    <input
                                        name="phone"
                                        type="tel"
                                        className = "add-club-form-input"
                                        placeholder={t('phoneNumberPlaceholder')}
                                        dir={isRTL ? 'rtl' : 'ltr'}
                                    />
                                </div>

                                <div className="add-club-terms-group">
                                    <input
                                        type="checkbox"
                                        name="terms"
                                        className="add-club-terms-checkbox"
                                        required
                                    />
                                    <span className="add-club-terms-text">
                                    {t("iAccept")}
                                        <a href="#" className="terms-link">{t("termsOfService")}</a>
                                    <span> {t("&")} </span>
                                    <a href="#" className="terms-link">{t("privacyPolicy")}</a>
                                </span>
                                </div>
                            </div>
                                <button
                                    type="submit"
                                    className="add-club-submit-button"
                                    disabled={loading}
                                >
                                    {loading ? t('joining') : t('join')}
                                </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default JoinClub;
